"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdDataviz = _interopRequireDefault(require("cccisd-dataviz"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _startCase2 = _interopRequireDefault(require("lodash/startCase"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _cccisdLaravelReport = require("cccisd-laravel-report");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ProgressReport = /*#__PURE__*/function (_Component) {
  _inherits(ProgressReport, _Component);
  function ProgressReport() {
    var _this;
    _classCallCheck(this, ProgressReport);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ProgressReport, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_getDataSeries", function () {
      var series = [];
      var sortedSeries = (0, _sortBy2["default"])(_this.props.reportProps.series, [function (s) {
        return s.order;
      }]);
      var firstRow = [(0, _startCase2["default"])(_this.props.reportProps.timepointLabel)];
      sortedSeries.forEach(function (s) {
        firstRow.push(s.name);
        firstRow.push({
          role: 'annotation'
        });
      });
      series.push(firstRow);
      _this.props.sessions.forEach(function (session) {
        series.push(_this._getSessionRow(session, sortedSeries));
      });
      return series;
    });
    _defineProperty(_assertThisInitialized(_this), "_getSessionRow", function (session, sortedSeries) {
      var row = [session.label];
      sortedSeries.forEach(function (ss) {
        if ((0, _isNil2["default"])(session[ss.name])) {
          row.push(0);
          row.push(null);
        } else {
          row.push(Math.round(+session[ss.name]));
          row.push(Math.round(+session[ss.name]));
        }
      });
      return row;
    });
    // get chart data and type
    _defineProperty(_assertThisInitialized(_this), "_getChartObject", function () {
      return {
        chartType: 'ColumnChart',
        dataTable: _this._getDataSeries(),
        options: _this._getBarChartOptions()
      };
    });
    _defineProperty(_assertThisInitialized(_this), "_getVerticalScale", function () {
      var verticalTicks = [];
      var min = +_this.props.reportProps.verticalScaleMin;
      var max = +_this.props.reportProps.verticalScaleMax;
      var interval = +_this.props.reportProps.verticalScaleInterval;
      if (!interval) {
        if (max <= 5) {
          interval = 1;
        } else if (max < 25 && max > 5) {
          interval = 2;
        } else if (max >= 25 && max < 50) {
          interval = 5;
        } else if (max >= 50 && max < 90) {
          interval = 10;
        } else if (max > 90) {
          interval = 20;
        }
      }
      for (var i = min; i <= max;) {
        verticalTicks.push(i);
        i += interval;
      }
      return verticalTicks;
    });
    // get display options for chart based on passed in type
    _defineProperty(_assertThisInitialized(_this), "_getBarChartOptions", function () {
      return {
        legend: {
          position: 'right'
        },
        width: 670,
        chartArea: {
          left: 50,
          width: '70%'
        },
        annotations: {
          alwaysOutside: true
        },
        series: {
          0: {},
          1: {},
          2: {}
        },
        vAxis: {
          gridlines: {
            color: '#D3D3D3'
          },
          minorGridlines: {
            color: 'transparent'
          },
          ticks: _this._getVerticalScale(),
          title: _this.props.reportProps.yAxisLabel,
          titleTextStyle: {
            italic: false,
            color: '#999999'
          },
          viewWindow: {
            min: _this.props.reportProps.verticalScaleMin,
            max: _this.props.reportProps.verticalScaleMax
          }
        }
      };
    });
    return _this;
  }
  _createClass(ProgressReport, [{
    key: "render",
    value: function render() {
      var isReport = this.props.isReport;
      var reportStyle = isReport ? _style["default"].report + ' ' + _style["default"].paginated : _style["default"].report;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: reportStyle
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Report, {
        showPagination: isReport
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].toPdf
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportWrapper
      }, this.props.header, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportContentWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].contentWrapper
      }, /*#__PURE__*/_react["default"].createElement("h1", null, this.props.reportProps.reportTitle), /*#__PURE__*/_react["default"].createElement("p", null, this.props.reportProps.description), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].chartContent
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].barChart
      }, /*#__PURE__*/_react["default"].createElement(_cccisdDataviz["default"], {
        chartData: this._getChartObject()
      }))))))))));
    }
  }]);
  return ProgressReport;
}(_react.Component);
_defineProperty(ProgressReport, "defaultProps", {
  isReport: false
});
ProgressReport.propTypes = {
  sessions: _propTypes["default"].array,
  reportProps: _propTypes["default"].object,
  isReport: _propTypes["default"].bool,
  /**
   * Full rendered markup for the header
   */
  header: _propTypes["default"].node
};
var _default = exports["default"] = ProgressReport;